import SelectOption from "@/common/ui/presenters/select-option";
import { Service } from "@/api/gateways/user-service-api";

export default function ServiceOptionDecorator(service: Service): SelectOption {
  return {
    text: service.name,
    value: String(service.id)
  };
}
